import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { respiAllerGradingReadSectionsV1 } from './respiAllerGrading/v1/respiAllerGradingReadSectionsV1';
import {
    respiAllerGradingDraftSchema,
    respiAllerGradingFinalSchema,
} from './respiAllerGrading/v1/respiAllerGradingSchemaV1';
import { respiAllerPrickTestMeasurementsReadSectionsV1 } from './respiAllerPrickTestMeasurements/v1/respiAllerPrickTestMeasurementsReadSectionsV1';
import {
    respiAllerPrickTestMeasurementsDraftSchema,
    respiAllerPrickTestMeasurementsFinalSchema,
} from './respiAllerPrickTestMeasurements/v1/respiAllerPrickTestMeasurementsSchemaV1';
import { respiAllerQuestionnaireReadSectionsV1 } from './respiAllerQuestionnaire/v1/respiAllerQuestionnaireReadSectionsV1';
import {
    respiAllerQuestionnaireDraftSchema,
    respiAllerQuestionnaireFinalSchema,
} from './respiAllerQuestionnaire/v1/respiAllerQuestionnaireSchemaV1';
import { respiAllerQuestionnaireStatusSchema } from './respiAllerQuestionnaireStatusSchema';
import { respiAllerReferralReadSectionsV1 } from './respiAllerReferral/v1/respiAllerReferralReadSectionsV1';
import {
    respiAllerReferralDraftSchema,
    respiAllerReferralFinalSchema,
} from './respiAllerReferral/v1/respiAllerReferralSchemaV1';
import {
    respiAllerResendQuestionnaireDraftSchema,
    respiAllerResendQuestionnaireFinalSchema,
} from './respiAllerResendQuestionnaireSchema';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.RespiAllerReferral,
        draft: respiAllerReferralDraftSchema,
        final: respiAllerReferralFinalSchema,
        readSections: respiAllerReferralReadSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.RespiAllerQuestionnaire,
        draft: respiAllerQuestionnaireDraftSchema,
        final: respiAllerQuestionnaireFinalSchema,
        readSections: respiAllerQuestionnaireReadSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.RespiAllerGrading,
        draft: respiAllerGradingDraftSchema,
        final: respiAllerGradingFinalSchema,
        readSections: respiAllerGradingReadSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.RespiAllerQuestionnaireStatus,
        draft: respiAllerQuestionnaireStatusSchema,
        final: respiAllerQuestionnaireStatusSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.RespiAllerResendQuestionnaire,
        draft: respiAllerResendQuestionnaireDraftSchema,
        final: respiAllerResendQuestionnaireFinalSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.RespiAllerPrickTestMeasurements,
        draft: respiAllerPrickTestMeasurementsDraftSchema,
        final: respiAllerPrickTestMeasurementsFinalSchema,
        readSections: respiAllerPrickTestMeasurementsReadSectionsV1,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
